import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=c5d4c1ee&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5d4c1ee')) {
      api.createRecord('c5d4c1ee', component.options)
    } else {
      api.reload('c5d4c1ee', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=c5d4c1ee&", function () {
      api.rerender('c5d4c1ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2U6Kxhn3ADqJo/JS/offershelp.vue"
export default component.exports